<template lang="html">

  <article>

   <div class="contenedor-input type-text one-slot -wo-margin">
    <label for="">Nombre de la documentación*</label>
    <input type="text" :style="style.input_black" v-validate="'required'" name="nombredocumentacion" v-model="nombredocumentacion">
    <span class='error' v-if="clicked">{{ errors.first('nombredocumentacion') }}</span>
  </div>

  <div class="dropzone row-center">

    <div class="text" v-if="!attached">
      <span class="upload-icon-wrapper"><upload-icon class="tag-icon"></upload-icon></span>
      <p>Arrastra el archivo o haz click para adjuntar</p>
    </div>
    
    <div class="text" v-else-if="attached && !errors.first('file')">
      <span class="upload-icon-wrapper"><success-icon class="tag-icon"></success-icon></span>
      <p>Archivo adjuntado correctamente</p>
    </div>
    
    <div class="text" v-else>
      <span class="upload-icon-wrapper"><upload-icon class="tag-icon"></upload-icon></span>
      <p>Arrastra el archivo o haz click para adjuntar</p>
    </div>


    <input type="file" id="file" name="file" ref="file"
    @change="handleFileUpload($event)"
    v-validate="`size:5000|mimes:${formatosPermitidos}|required`"
    :class="[{'has-error' : errors.has('file')}]"/>
    
    <span class='error' v-if="errors.items[0] && errors.items[0].rule=='required'">{{ 'Faltan campos obligatorios' }}</span>
    <span class='error' v-else-if="errors.items[0] && errors.items[0].rule=='size'">{{ 'El tamaño del archivo supera el máximo de 5MB' }}</span>
    <span class='error' v-else>{{ errors.first('file') }}</span>

  </div>

  <a class="btn add-documentacion -xs" :style="style.solidPrimary" :loading="loading" @click="send">Añadir {{calculatetype}}</a>
  <a class="btn -skull -xs" :style="style.skull_primary" @click="close">Cancelar</a>


</article>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import uploadIcon from '@/components/parts/icons/upload'
  import successIcon from '@/components/parts/icons/success'

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  export default  {
    name: 'add-documentacion',
    components : {
      'upload-icon' : uploadIcon,
      'success-icon' : successIcon,
    },
    props : ['type'],
    data(){
      return {
        clicked : false,
        loading : false,
        attached : false,
        base64 : '',
        nombredocumentacion : '',
        extension : '',
        formatosPermitidos : [
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/pdf',
          'application/msword',
          'application/vnd.oasis.opendocument.text',
          'application/vnd.ms-powerpoint',
          'application/vnd.oasis.opendocument.presentation',
          'application/vnd.ms-excel',
          'vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'image/png',
          'image/jpg',
          'image/jpeg',
          'image/*',
          '',
          'docx','pptx','pdf','odt','ppt','odp','csv','xlsx','doc'],
        relacionFormato : {
          'vnd.openxmlformats-officedocument.wordprocessingml.document' : 'docx',
          'vnd.openxmlformats-officedocument.presentationml.presentation' : 'pptx',
          'pdf' : 'pdf',
          'msword' : 'doc',
          'application/msword' : 'doc',
          'vnd.oasis.opendocument.text' : 'odt',
          'vnd.ms-powerpoint' : 'ppt',
          'vnd.oasis.opendocument.presentation' : 'odp',
          'vnd.ms-excel' : 'csv',
          'vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'xlsx',
          'msword' : 'doc',
          'image/png' : 'png',
          'image/jpg' : 'jpg',
          'image/jpeg' : 'jpeg',
          'application/pdf' : 'pdf'
        }
      }
    },
    computed :{
      ...mapGetters({
        style : 'getStyles',
      }),
      calculatetype(){
        let types = {
          'addDocumentoPracticaParaAlumno' : 'Evaluación',
          'addDocumentoPractica' : 'Documentación',
        }

        return types[this.type];
      }
    },
    methods : {
      ...mapActions(['addDocumentoPractica']),
      handleFileUpload(event){
        this.clicked = true;
        let file = event.target.files[0];
        let filetype = (!!file.type) ? file.type : file.name.split(".").pop();

        console.log(filetype);

        
        if(this.formatosPermitidos.some(f => f.includes(filetype))){
          this.attached = true;
          this.extension = (!!this.relacionFormato[filetype]) ? this.relacionFormato[filetype] : filetype;
        }

        this.getBase64(file).then(data => {
          this.base64 = data;
        });

      },
      getBase64: function(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
      send(){
        this.clicked = true;
        this.$validator.validateAll().then(itsOk => {
          if(itsOk){
            this.loading = true;

            let id = this.$route.params.id;

            if(!!!id & Number(this.$route.params.status) > 0){
              id = this.$route.params.status;
            }

            

            let request = {
              idPractica: id,
              nombre:this.nombredocumentacion,
              extension_adjunto: this.extension,
              ficheroB64: this.base64
            }

            let data = {
              type : this.type,
              request : request
            };

            this.addDocumentoPractica(data).then(r => {
              if(!!r.enlace){
                let data = {
                  idDocumento: r.idDocumento,
                  enlace : r.enlace,
                  nombre : this.nombredocumentacion
                }

                this.$emit('setdocumentacion',data);
              }
            }).catch( e => {
              this.loading = false;
            });
          }
        });
      },
      close(){
        this.$emit('close');
      }
    }
  }
</script>

<style scoped lang="scss">

  article{
    text-align: left;
    width: 100%;
  }

  .contenedor-input{
    margin-top: 20px;
    margin-bottom: 10px;
  }


  .dropzone{
    width: 100%;
    min-height: 130px;
    background: #f2f2f2;
    padding: 50px;
    position: relative;
    text-align: center;

    p{
      text-align: center;
      margin-top: 10px;
    }

    input{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 3;
    }

    svg{
      width: 40px;
      height: 40px;
      filter: grayscale(1);
      opacity: .5
    }
    
    .error{
      font-size: 13px;
      width: 100%;
      color: red;
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: 10px;
      left: 0;
    }

  }




  .dropzone + .btn{
    margin-top: 20px;
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/parts/add-documentacion.vue